<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-layout justify-center style="flex-wrap: wrap">
          <v-radio-group row justify-center v-model="filter" @change="loadTable()">
            <v-radio :label="$t('active_f_p')" value="enabled"></v-radio>
            <v-radio :label="$t('portal_request')" value="request"></v-radio>
            <v-radio :label="$t('to_approve')" value="approve"></v-radio>
            <v-radio :label="$t('all_f_p')" value="all"></v-radio>
          </v-radio-group>
          <v-btn class="mx-2 my-2" small @click="extractCsvAsd" color="primary">{{
            $t("extract_csv")
          }}</v-btn>
          <v-btn v-if="RBAC_ente_CREATE_ASD" small class="mx-2 my-2" @click="createASD_no_portal" color="primary">{{
            $t("create_asd_with_no_portal") }}</v-btn>
          <v-btn icon color="primary" large style="float: right" @click="loadTable()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-layout>
        <DataTables @listImpianti="listImpianti" @approveModify="approveModify" @viewAssociazione="viewAssociazione"
          @approveRequestOrder="approveRequestOrder" @viewConsiglio="viewConsiglio" @viewDocument="viewDocument" @viewAffiliazioni="viewAffiliazioni"
          @editDiscipline="editDiscipline" @deleteAssociazione="deleteAssociazione" @managePortal="managePortal"
          @extractCsvTesserati="extractCsvTesserati" :headers="headers" :tableData="tableData"></DataTables>
        <list-ente-impianti ref="listImpianti"></list-ente-impianti>
        <edit-associazione @isUpdated="loadTable" ref="viewAssociazione"></edit-associazione>
        <edit-consiglio @isUpdated="loadTable" ref="viewConsiglio"></edit-consiglio>
        <edit-documenti @isUpdated="loadTable" ref="viewDocument"></edit-documenti>
        <edit-affiliazioni @isUpdated="loadTable" ref="viewAffiliazioni"></edit-affiliazioni>
        <manage-portal @isUpdated="loadTable" ref="managePortal"></manage-portal>
        <edit-discipline @isUpdated="loadTable" ref="editDiscipline" :title="$t('view_disciplines')" type="dialog"
          method="VIEW" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gestAssociazione from "@/app/ente/gestAssociazione.vue";
import gestConsiglio from "@/app/ente/gestConsiglio.vue";
import gestDiscipline from "@/app/ente/gestDiscipline.vue";
import listImpianti from "@/app/ente/listImpianti.vue";
import DataTables from "@/components/base/DataTables.vue";
import gestDocumenti from "@/app/ente/gestDocumenti.vue";
import gestAsdAffiliazioni from "@/app/ente/gestAsdAffiliazioni.vue";
import managePortal from "@/app/admin/managePortal.vue";
import Swal from "sweetalert2";

export default {
  name: "list-associazioni",
  components: {
    DataTables,
    "edit-discipline": gestDiscipline,
    "edit-consiglio": gestConsiglio,
    "edit-documenti": gestDocumenti,
    "edit-affiliazioni": gestAsdAffiliazioni,
    "edit-associazione": gestAssociazione,
    "manage-portal": managePortal,
    "list-ente-impianti": listImpianti,
  },
  data() {
    return {
      filter: "all",
      RBAC_ente_CREATE_ASD: false,
      RBAC_system_CAN_DEPLOY: false,
      headers: [
        { text: this.$t("portal"), value: "iconPortal", type: "buttons" },
        { text: this.$t("website"), value: "links", type: "links" },
        { text: this.$t("enabled_f"), value: "iconEnabled", type: "icons" },
        { text: this.$t("to_approve"), value: "btnApprove", type: "buttons" },
        { text: this.$t("code"), value: "internalCode" },
        { text: this.$t("code_society"), value: "codiSoc" },
        { text: this.$t("affiliation_type"), value: "asdAffiliazione" },
        { text: this.$t("convention"), value: "convenzione" },
        { text: this.$t("ragSoc"), value: "ragSoc" },
        { text: this.$t("location"), value: "sedLegComune" },
        { text: this.$t("resp_legal"), value: "respLegale" },
        // { text: this.$t("ref_person"), value: "refNome" },
        // { text: this.$t("ref_telephone"), value: "refTel" },
        // { text: this.$t("ref_email"), value: "refEmail" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    extractCsvAsd() {
      let link = this.authorizeLink("/auth/portal/csv/asdList");
      window.open(link);
    },
    extractCsvTesserati(item) {
      let params = { asdCode: item.code };
      let link = this.authorizeLink(
        "/auth/ente/getFileTesserati/snapshot/" + btoa(JSON.stringify(params))
      );

      window.open(link);
    },
    createASD_no_portal() {
      this.$refs.viewAssociazione.open("ADD", "");
    },
    editDiscipline(item) {
      this.$refs.editDiscipline.open("VIEW", item.code);
    },
    approveModify(item) {
      this.$router.push("/portal/ente/approveModify/" + item.code);
    },
    viewDocument(item) {
      this.$refs.viewDocument.open("APPROVE", item.code);
    },
    viewAffiliazioni(item) {
      this.$refs.viewAffiliazioni.open("VIEW", item.code);
    },
    viewConsiglio(item) {
      this.$refs.viewConsiglio.open("APPROVE", item.code);
    },
    viewAssociazione(item) {
      this.$refs.viewAssociazione.open("EDIT", item.code);
    },
    approveRequestOrder(item) {
      this.$refs.viewAssociazione.open("PORTAL_REQUEST", item.orderId);
    },
    listImpianti(item) {
      this.$refs.listImpianti.open(item.code);
    },
    managePortal(item) {
      console.dir(JSON.stringify(item));
      if (this.adminPortal) this.$refs.managePortal.open(item.code);
    },
    deleteAssociazione(item) {
      let _ = this;
      let checkString = (Math.random() + 1).toString(36).substring(7)
      Swal.fire({
        title: this.$t("delete") + " " + item.code + "! " + this.$t("are_you_sure_?"),
        html: this.$t("you_cant_revert_this") + "<br><br>" + this.$t("write_this_text_for_confirm") + "<br><br><b>" + checkString + "</b>",
        type: "warning",
        input: 'text',
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        inputPlaceholder: checkString,
        buttonsStyling: true,
        preConfirm: (result) => {
          if (result === checkString) return true;
          else {
            Swal.showValidationMessage(
              _.$t("invalid_code") + ": " + result
            )
          }
        },
      }).then((result) => {
        if (result && result.value) {
          _.chiamataAxios("DELETE", "/auth/ente/deleteAsdInfo/" + item.code, {
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadTable();
            }
          });
        }
      });
    },
    loadTable() {
      let _ = this;
      let now = new Date();
      this.chiamataAxios("POST", "/auth/ente/listAsd", {
        body: { filter: { status: _.filter } },
      }).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          if (_.RBAC_system_CAN_DEPLOY && !item.isRequest)
            item.iconPortal = [
              {
                icon: "mdi-earth",
                color: "primary",
                text: _.$t("manage_portal"),
                function: "managePortal",
              },
            ];
          item.links = [];
          if (item.hostname) {
            item.links.push({
              url: item.fullHostname,
              text: item.hostname,
              color: "secondary",
            });
          }
          if (item.webSite && item.webSite !== "") {
            item.links.push({
              url: item.webSite.startsWith('http') ? item.webSite : 'https://' + item.webSite,
              text: item.webSite,
              color: "secondary",
            });
          }
          if (item.toApprove)
            item.btnApprove = [
              {
                icon: "mdi-timer-sand",
                color: "warning",
                text: _.$t("approve_association"),
                function: "approveModify",
              },
            ];

          if (item.enabled)
            item.iconEnabled = [{ icon: "mdi-check", color: "success" }];

          let colorDoc = "success";
          if (!item.haveDoc && !item.havePartialDoc) colorDoc = "error";
          if (item.havePartialDoc) colorDoc = "orange";
          if (item.toApproveDoc) colorDoc = "warning";
          if (item.isRequest)
            item.options = [
              {
                icon: "mdi-help-box",
                color: "warning",
                text: _.$t("approve_request"),
                function: "approveRequestOrder",
              },
            ];
          else
            item.options = [
              {
                icon: "mdi-magnify",
                color: !item.compiled
                  ? "error"
                  : item.toApproveAsdInfo
                    ? "warning"
                    : "success",
                text: _.$t("view_association"),
                function: "viewAssociazione",
              },
              {
                icon: "mdi-handshake-outline",
                color: "success",
                text: _.$t("view_affiliations"),
                function: "viewAffiliazioni",
              },
              {
                icon: "mdi-account-group",
                color: !item.haveConsiglio
                  ? "error"
                  : item.toApproveConsiglio
                    ? "warning"
                    : "success",
                text: _.$t("view_council"),
                function: "viewConsiglio",
              },
              {
                icon: "mdi-file-document-outline",
                color: colorDoc,
                text: _.$t("view_asd_document"),
                function: "viewDocument",
              },
              {
                icon: "mdi-earth",
                color: "secondary",
                text: _.$t("sport_facilities"),
                function: "listImpianti",
              },
              {
                icon: "mdi-run-fast",
                color: "secondary",
                text: _.$t("view_disciplines"),
                function: "editDiscipline",
              },
              {
                icon: "mdi-file-download",
                color: "secondary",
                text: _.$t("extract_csv_affiliated"),
                function: "extractCsvTesserati",
              },
            ];

          if (!item.myAsd) {
            item.options.push({
              icon: "mdi-delete",
              color: "error",
              text: _.$t("delete"),
              function: "deleteAssociazione",
            });
          }
          return item;
        });
      });
    },
  },
  mounted() {
    this.RBAC_ente_CREATE_ASD = this.checkUserRole("ente", "CREATE_ASD");
    this.RBAC_system_CAN_DEPLOY = this.checkUserRole("system", "CAN_DEPLOY");
    this.tableData = [];
    this.loadTable();
  },
  computed: {
    adminPortal() {
      if (window.systemData) return window.systemData.adminPortal;
      else return false;
    },
  },
};
</script>